import * as moment from "moment";

import { SecondaryCaseStatus, secondaryCaseStatusOptions } from "@teamprevent/common/workAdjustment/models";

export interface ChangeWorkAdjustmentCaseSecondaryStatusModel {
    secondaryStatus: SecondaryCaseStatus;
    newNotes: string;
}

export interface SecondaryCaseStatusChangeEntry {
    userName: string;
    notes: string;
    secondaryStatus: SecondaryCaseStatus;
    createdDate: moment.Moment;
}

export const getPreviousNotes = (notesEntries: SecondaryCaseStatusChangeEntry[]): string => {
    const entries = (notesEntries ?? []).map(getSecondaryStatusChangeNotesEntry);
    return entries.join("\r\n");
};

const getSecondaryStatusChangeNotesEntry = (e: SecondaryCaseStatusChangeEntry): string => {
    const createdDate = e.createdDate && moment(e.createdDate);
    const result = e.userName + "; Status: " + getSecondaryStatusText(e.secondaryStatus) + "; Notes: " + e.notes + "; " + createdDate.format(DATE_FORMAT);
    return result;
};

const getSecondaryStatusText = (status: SecondaryCaseStatus) => {
    return secondaryCaseStatusOptions.find(o => o.value === status).text;
};

const DATE_FORMAT = "LLLL";
